'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transformNowPlayingResponseData;

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transformNowPlayingResponseData(data) {
  if ((0, _isObject2.default)(data) && (data.secondary || data.primary)) {
    var nowPlayingResponse = data.secondary || data.primary;
    var header = data.header;

    var nowPlaying = {
      ads: data.ads,
      classification: data.classification,
      primaryGuideId: data.primary ? data.primary.guideId : undefined,
      secondaryGuideId: data.secondary ? data.secondary.guideId : undefined,
      header: header,
      title: header.subtitle,
      subtitle: header.title,
      image: nowPlayingResponse.image,
      followOptions: data.follow.options,
      switchAction: data.switch,
      upsell: data.upsell,
      ttl: data.ttl * 1000,
      share: data.share,
      popup: data.popup,
      containerNavigation: data.containerNavigation
    };

    return { nowPlaying: nowPlaying, token: data.token };
  }

  return data;
}
//# sourceMappingURL=transformNowPlayingResponseData.js.map